export default "__VITE_ASSET__CnEt$$KW__"